import { CodeBase } from "./_codeBase";

/**
 * box使用区分
 **/
export class BoxUseDiv extends CodeBase<BoxUseDiv>
{
    /** box使用区分: "01", "box使用禁止"*/
    public static readonly UNAVAILABLE: BoxUseDiv = new BoxUseDiv("01", "box使用禁止", "");
    /** box使用区分: "02", "サブプロジェクト管理者以上のみアップロード可能"*/
    public static readonly CONDITIONAL: BoxUseDiv = new BoxUseDiv("02", "サブプロジェクト管理者以上のみアップロード可能", "");
    /** box使用区分: "03", "box使用可能"*/
    public static readonly AVAILABLE: BoxUseDiv = new BoxUseDiv("03", "box使用可能", "");

    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): BoxUseDiv[] {
        return [
            BoxUseDiv.UNAVAILABLE,
            BoxUseDiv.CONDITIONAL,
            BoxUseDiv.AVAILABLE,

        ];
    }
}
